/**
 * Loop through the given configuration, creating
 * resolvers for every key.
 */
export function i18nextToDefaultResolvers(i18nextConfiguration) {
  const { properties } = i18nextConfiguration.definitions.namespaces;
  const resolvers = {};
  const clientWarning = obj => {
    if (process.env.NODE_ENV !== 'test') {
      console.log('A @client directive has been used for:');
      console.log(obj);
      console.log(
        'Make sure these are removed before being released to production.'
      );
    }
  };
  const makePropertyResolver = (properties, key) => {
    return (obj, args, context, info) => {
      clientWarning(obj);
      return properties[key].default;
    };
  };

  Object.keys(properties).forEach(namespace => {
    const nsProperties = properties[namespace].properties;
    const defaultField = properties[namespace].default;
    let returnValue;

    // Create resolvers for every attribute of each property if there isn't a global default.
    if (
      Object.keys(defaultField).length === 0 &&
      defaultField.constructor === Object
    ) {
      returnValue = {};

      for (var key in nsProperties) {
        returnValue[key] = makePropertyResolver(nsProperties, key);
      }
    }

    // Create a resolver for just the attribute itself.
    else {
      returnValue = (obj, args, context, info) => {
        clientWarning(obj);
        return properties[namespace].default;
      };
    }

    resolvers[
      `HotelOnlyBooking${namespace
        .charAt(0)
        .toUpperCase()
        .concat(namespace.slice(1))}Translations`
    ] = returnValue;
  });
  return resolvers;
}
